import { reactive, ref } from "vue";
import { verifyMFA } from "@/service/login";
export function useMFA(config) {
    const { needBind, ...rest } = config;
    const MFAForm = ref();
    const MFAData = reactive({
        num: null
    });
    const MFARules = reactive({
        num: [{ required: true, message: "请输入验证码~", trigger: "blur" }]
    });
    const submit = () => {
        return new Promise((resolve) => {
            MFAForm.value.validate((valid) => {
                if (valid) {
                    const params = {
                        code: MFAData.num,
                        need_bind: needBind ? 1 : 0,
                        ...rest
                    };
                    verifyMFA(params).then(() => {
                        MFAForm.value.resetFields();
                        resolve();
                    });
                }
            });
        });
    };
    const reset = () => {
        MFAForm.value.resetFields();
    };
    return {
        MFAForm,
        MFAData,
        MFARules,
        submit,
        reset
    };
}
